import MobileSectionGames from './MobileSectionGames';

export default MobileSectionGames;
